import { http } from "../utils/http";

/** Test results stored without a candidate (общая ссылка на тест). */
export const getUnlinkedTestResults = () => http.get("/test-results/unlinked");

export const linkTestResult = (kind, resultId, candidateId) =>
    http.post(
        `/test-results/${encodeURIComponent(kind)}/${encodeURIComponent(resultId)}/link`,
        { candidate_id: Number(candidateId) }
    );

/** Правка №2: удалить результат, не привязанный к кандидату (только HR). */
export const deleteUnlinkedTestResult = (kind, id) =>
    http.del(`/test-results/${encodeURIComponent(kind)}/${encodeURIComponent(id)}`);
